<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='""' class="container-fluid" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="row mx-auto justify-content-center" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="col-lg-6 mx-auto" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="form-wrapper-1" >
                <template #default>   <m-h3 v-bind='{...{},...{}}' :style='"font-size:24px;"' class="my-4 pb-4" >
                <template #default>مشخصات ملک خود را ثبت کنید   </template>
                </m-h3><m-form-single-1 v-bind='{...{"itemClass":"col-lg-12 mb-3","formId":1,"redirectToDashboard":false,"redirectDirectLink":""},...{}}' :style='""' class="" ></m-form-single-1></template>
                </m-div></template>
                </m-div></template>
                </m-div></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mH3 from '@moeinmdn/miw-alpha-components/src/package/Tags/H3'; import mFormSingle1 from '@moeinmdn/miw-alpha-components/src/package/Form/FormSingle/FormSingle1';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mH3,mFormSingle1 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
